/**
 * [pug template]
 */
<template lang="pug">
    input(:id="name", v-model="selected", type="checkbox", @change="change(name)", :value="value")
</template>
/**
 * [javascript application]
 */
<script>
export default {
  name: 'checkbox-component',
  props: {
    name: {
      type: String,
      default: ''
    },
    change: {
      type: Function,
      default: function () {}
    },
    value: {},
    isChecked: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      selected: this.isChecked
    }
  },
  watch: {
    selected: function (newValue, oldValue) {
      this.$emit('value-changed', newValue)
    },
    isChecked: function (newValue, oldValue) {
      this.selected = newValue
    }
  }
}
</script>
/**
 * [scss styles]
 */
<style scoped lang="scss">
</style>




// WEBPACK FOOTER //
// CheckboxComponent.vue?78d262dc